// {{key}} substitution + the catalog of placeholders the editor can offer.

const PLACEHOLDER_RE = /\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g;

export function interpolate(template, data) {
  if (template === null || template === undefined) return "";
  const noData = data === null || data === undefined;
  const d = noData ? {} : data;
  return String(template).replace(PLACEHOLDER_RE, (whole, key) => {
    if (noData) return "";
    if (!Object.prototype.hasOwnProperty.call(d, key)) return whole;
    const v = d[key];
    return v === null || v === undefined ? "" : String(v);
  });
}

// Groups carry an optional `templates` whitelist — only those templates see
// the group. When `templates` is missing, the group shows everywhere.
export const PLACEHOLDER_GROUPS = [
  {
    label: "Open House",
    templates: [
      "scheduling-seller", "scheduling-agent",
      "update-seller", "update-agent",
      "cancellation-seller", "cancellation-agent",
      "recap-seller",
    ],
    items: [
      { key: "propertyAddress", display: "Property Address", icon: "📍" },
      { key: "date",             display: "Date",             icon: "🗓" },
      { key: "time",             display: "Time",             icon: "⏱" },
    ],
  },
  {
    label: "Seller",
    templates: [
      "scheduling-seller", "update-seller", "cancellation-seller",
      "recap-seller",
    ],
    items: [
      { key: "sellerFirstName", display: "Seller first name", icon: "👤" },
      { key: "sellerName",      display: "Seller full name",  icon: "👤" },
    ],
  },
  {
    label: "Hosting Agent",
    templates: [
      "scheduling-seller", "scheduling-agent",
      "update-seller", "update-agent",
      "cancellation-seller", "cancellation-agent",
    ],
    items: [
      { key: "hostingAgentFirstName", display: "Hosting agent first name", icon: "🧑" },
      { key: "hostingAgentName",      display: "Hosting agent full name",  icon: "🧑" },
    ],
  },
  {
    label: "Feedback",
    templates: ["recap-seller"],
    items: [
      { key: "groups",         display: "# of groups",        icon: "👥" },
      { key: "secondShowings", display: "# of 2nd showings",  icon: "🔁" },
      { key: "agentFeedback",  display: "Agent feedback",     icon: "💬" },
      { key: "buyerFeedback",  display: "Buyer feedback",     icon: "💬" },
      { key: "otherComments",  display: "Other comments",     icon: "💬" },
    ],
  },
  // ===== Client touchpoints + marketing templates =====
  {
    label: "Contact",
    templates: [
      "birthday", "home-anniversary", "closing-day", "welcome",
      "just-listed", "just-sold",
    ],
    items: [
      { key: "contactFirstName", display: "Contact first name", icon: "👤" },
      { key: "contactName",      display: "Contact full name",  icon: "👤" },
    ],
  },
  {
    label: "Property",
    templates: [
      "home-anniversary", "closing-day", "just-listed", "just-sold",
    ],
    items: [
      { key: "propertyAddress", display: "Property Address", icon: "📍" },
    ],
  },
  {
    label: "Anniversary",
    templates: ["home-anniversary"],
    items: [
      { key: "yearsInHome", display: "Years in home", icon: "🎉" },
    ],
  },
  {
    label: "Sender",
    templates: [
      "birthday", "home-anniversary", "closing-day", "welcome",
      "just-listed", "just-sold",
      "staging-consult-vendor", "staging-install-vendor", "staging-destage-vendor",
      "photographer-vendor", "pre-inspection-vendor",
    ],
    items: [
      { key: "senderFirstName", display: "Your first name", icon: "✍️" },
      { key: "senderName",      display: "Your full name",  icon: "✍️" },
    ],
  },
  // ===== Vendor Notifications =====
  {
    label: "Vendor",
    templates: [
      "staging-consult-vendor", "staging-install-vendor", "staging-destage-vendor",
      "photographer-vendor", "pre-inspection-vendor",
    ],
    items: [
      { key: "vendorName", display: "Vendor name", icon: "🏠" },
    ],
  },
  {
    label: "Deal",
    templates: [
      "staging-consult-vendor", "staging-install-vendor", "staging-destage-vendor",
      "photographer-vendor", "pre-inspection-vendor",
    ],
    items: [
      { key: "propertyAddress", display: "Property Address", icon: "📍" },
      { key: "clients",          display: "Clients",         icon: "👥" },
      { key: "closingDate",      display: "Closing Date",    icon: "🗓" },
      { key: "targetListDate",   display: "Target List Date", icon: "🗓" },
    ],
  },
  {
    label: "Schedule",
    templates: ["staging-install-vendor"],
    items: [
      { key: "installDate", display: "Install Date", icon: "🗓" },
    ],
  },
  {
    label: "Schedule",
    templates: ["staging-destage-vendor"],
    items: [
      { key: "destageDate", display: "Destage Date", icon: "🗓" },
    ],
  },
  {
    label: "Schedule",
    templates: ["photographer-vendor"],
    items: [
      { key: "photoshootDate", display: "Photoshoot Date", icon: "🗓" },
    ],
  },
  {
    label: "Inspections",
    templates: ["pre-inspection-vendor"],
    items: [
      { key: "inspectionList", display: "Inspection list", icon: "📋" },
    ],
  },
  {
    label: "Lockbox",
    templates: [
      "staging-consult-vendor", "staging-install-vendor", "staging-destage-vendor",
      "photographer-vendor", "pre-inspection-vendor",
    ],
    items: [
      { key: "lockboxType",   display: "Lockbox type",   icon: "🔐" },
      { key: "lockboxNumber", display: "Lockbox number", icon: "🔢" },
      { key: "lockboxCode",   display: "Lockbox code",   icon: "🔑" },
    ],
  },
];

export function placeholdersFor(templateId) {
  return PLACEHOLDER_GROUPS.filter(
    (g) => !g.templates || g.templates.includes(templateId),
  );
}
